/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { LocalStorageService } from '../../../../../utils/src/lib/local-storage/local-storage.service';
import { Store } from '@ngrx/store';
import { BackendService } from '../../../../../utils/src';
import { SystemInfo } from '../../../../../data-access/src/lib/domain/system-info';
import { IDeleteSystemCategoryFacade } from 'libs/sysque/toolbelt/data-access/src/lib/domain/facades-models/delete-system-category-facade-interface';
import { SysqueElectricalState } from '../../models/sysque-electrical-state';
import { GlobalConstants } from '../../constants/global-constants';
import { SysQueCategoryOperationsResult, SysQueSystemsOperationsResult } from '../../models/sysque-systems-operations';
import { TabDescription } from 'libs/sysque/toolbelt/data-access/src/lib/domain/tab-description';

@Injectable({
  providedIn: 'root',
})
export class DeleteSystemCategoryFacade implements IDeleteSystemCategoryFacade {
  constructor(
    private localStorageService: LocalStorageService,
    public store: Store,
    public backendService: BackendService
  ) {}

  public removeSystem(nameOfRequest: string, systemName: string): Observable<SysQueSystemsOperationsResult> {
    return from<Promise<SysQueSystemsOperationsResult>>(
      this.backendService.messageHandler.sendRequestAsync(nameOfRequest, [systemName])
    );
  }

  public deleteCategory(
    requestName: string,
    categoryName: string,
    systemName: string
  ): Observable<SysQueCategoryOperationsResult> {
    return from<Promise<SysQueCategoryOperationsResult>>(
      this.backendService.messageHandler.sendRequestAsync(requestName, [categoryName, systemName])
    );
  }

  public closeWindow(): Observable<any> {
    return from<Promise<any>>(this.backendService.messageHandler.sendRequestAsync(GlobalConstants.OnCloseWindow));
  }

  public windowResize(height: number): Observable<any> {
    return from<Promise<any>>(this.backendService.messageHandler.sendRequestAsync(GlobalConstants.ChangeHeight, [height]));
  }

  public updateSystemInfo(systems: SystemInfo[], categories: TabDescription[]): void {
    const state = this.getSystemState();
    if (categories !== null) {
      state.categoryList = categories;
    }
    if (systems !== null) {
      state.systemList = systems;
    }
    this.localStorageService.updateDispatchLocalStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY, state);
  }

  public getSystemState(): SysqueElectricalState {
    return this.localStorageService.getStorage(GlobalConstants.SYSQUE_ELECTRICAL_STATE_KEY) as SysqueElectricalState;
  }
}
